import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, allowedRoles = ["owner", "developer"] }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#475569]" data-testid="admin-auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  if (!allowedRoles.includes(user.role)) {
    // Signed in but wrong role: developers bounce to dev dashboard,
    // anyone else bounces to login.
    return <Navigate to={user.role === "developer" ? "/admin/dev" : "/admin/login"} replace />;
  }
  return children;
}
